import React, { useEffect } from 'react';
import { Grid, Button } from '@material-ui/core';
import { ModalWrapper } from 'components/Modals';
import DeleteIcon from '@material-ui/icons/Delete';
import './DeleteTeamModal.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { LoaderButton } from 'components/LoaderButton';
import { resetDeleteTeamSuccess } from 'redux/actions/team';
import { deleteTeam as deleteTeamThunk } from 'redux/thunks';

interface DeleteModalProps {
	open: boolean;
	teamName: string;
	teamId: string;
	onCloseClicked: () => void;
	allowClickOutsideToClose?: boolean;
}

const DeleteTeamModal: React.FC<DeleteModalProps> = (props: DeleteModalProps) => {
	const deletingTeam = useSelector((state: RootStore) => state.team.deletingTeam);
	const deletingTeamSuccess = useSelector((state: RootStore) => state.team.deletingTeamSuccess);
	const dispatch = useDispatch();
	const { open, teamId, teamName, allowClickOutsideToClose, onCloseClicked } = props;

	const deleteTeam = () => {
		dispatch(deleteTeamThunk(teamId));
	};

	useEffect(() => {
		if (deletingTeamSuccess) {
			dispatch(resetDeleteTeamSuccess());
			onCloseClicked();
		}
	}, [deletingTeamSuccess, dispatch, onCloseClicked]);

	return (
		<ModalWrapper open={open} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose}>
			<Grid container direction='column' alignItems='center' className='delete-modal'>
				<h3 className='delete-modal__title'>Delete {teamName}</h3>
				<div>Are you sure you want to delete {teamName}? This action cannot be undone.</div>
				<Grid justify='space-between' item container className='delete-modal-buttons__container'>
					<Button variant='contained' color='primary' onClick={onCloseClicked}>
						Back
					</Button>
					<LoaderButton
						type='button'
						loading={deletingTeam}
						onHandleClick={deleteTeam}
						variant='outlined'
						className='delete-modal__delete-button'
						startIcon={<DeleteIcon />}
					>
						Delete Team
					</LoaderButton>
				</Grid>
			</Grid>
		</ModalWrapper>
	);
};

export default DeleteTeamModal;
